<script>
export default {};
</script>

<template>
  <!--START SERVICES-->
  <section class="section pt-5" id="services">
    <!--<div class="row-aut">
      <div class="img col-lg-5-img">
        <img src="../assets/images/requi.jpg" alt="..." style="max-width: 100%; height: auto;">
      </div>
      <div class="col-lg-6-sa">
        <div class="offset-lg-2">
          <h1 class="section-title text-center"><br>Este seguro de Auto Turistas está diseñado para automóviles con placa
            americana y canadiense que por motivos de placer o negocio cruzan la frontera hacia México.</h1>
          <h1 class="section-title text-center"><br>Seguro de Auto Turistas.</h1>
          <div class="section-title-border margin-t-20"></div>
          <p class="section-subtitle text-muted text-center padding-t-30 font-secondary" style="width:95%; padding-left: 20px;">Diseñado para automóviles con
            placa
            americana y canadiense que por motivos de placer o negocio cruzan la frontera hacia México que deberán de
            acreditarse con
            registro y placas del país de procedencia.
            Cobertura únicamente en territorio Mexicano.</p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list" style="padding-left: 30px; padding-right: 12px;">
              <li>Vigencias diarias (corto plazo, semestrales y anuales)</li>
            <li>Conductores mayores de 18 años.</li>
            <li>Vehículos hasta con 20 años de antigüedad.</li>
          </ul>
          <a v-scroll-to="'#contact'" class="cont btn btn-custom btn-rounded margin-t-30 waves-effect waves-light">
            Contáctanos
            <i class="mdi mdi-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>-->
    <div class="container margin-t-20">
      <h1 class="section-title text-center"><br>Proceso de compra.</h1>
      <div class="section-title-border margin-t-20"></div>
      <p class="section-subtitle text-muted text-center padding-t-30 font-secondary">Optimiza tus gastos al obtener tu
        seguro en línea y evita sanciones al viajar.</p>

      <div class="row">
        <div class="col-lg-6 text-center process-left-icon-1">
          <i class="pe-7s-angle-right"></i>
        </div>
        <div class="col-lg-6 text-center process-left-icon-2">
          <i class="pe-7s-angle-right"></i>
        </div>
      </div>
      <div class="row margin-t-20">
        <div class="col-lg-4-3 plan-line">
          <div class="text-center process-box">
            <i class="pe-7s-car text-custom"></i>
            <h4 class="padding-t-15">Cotiza</h4>
            <p class="text-muted">Auto de USA viajando en México.</p>
          </div>
        </div>
        <div class="col-lg-4-3 plan-line">
          <div class="text-center process-box">
            <i class="pe-7s-pen text-custom"></i>
            <h4 class="padding-t-15">Compara</h4>
            <p class="text-muted">Compara al estar llenando el formulario.</p>
            <a href="https://public.nhseguros.com/#!policyIndividual/index?code=MjI4MDc%3D" target="_blank"
              class="btn btn-custom btn-rounded margin-t-50 waves-effect waves-light mb-5">Compra tu seguro</a>
          </div>
        </div>
        <div class="col-lg-4-3">
          <div class="text-center process-box">
            <i class="pe-7s-piggy text-custom"></i>
            <h4 class="padding-t-15">Compra</h4>
            <p class="text-muted">Compra tu seguro y disfruta del viaje.</p>
          </div>
        </div>
      </div>
      <div class="row vertical-content tequila margin-t-50">
        <div class="col-lg-4-2-1">
          <div class="services-box">
            <img src="../assets/images/cocktail.jpg" alt="..." style="max-width: 100%; height: auto; padding-top: 35px;">
          </div>
        </div>
        <div class="col-lg-4-2">
          <div class="services-box">
            <!--<h1 class="section-title text-center"><br>Este seguro de Auto Turistas está diseñado para automóviles con placa
              americana y canadiense que por motivos de placer o negocio cruzan la frontera hacia México.</h1>-->
            <h1 class="section-title text-center"><br>Seguro de Auto Turistas.</h1>
            <div class="section-title-border margin-t-20"></div>
            <p class="section-subtitle text-muted text-justify padding-t-30 font-secondary">Diseñado para automóviles con
              placa
              americana y canadiense que por motivos de placer o negocio cruzan la frontera hacia México que deberán de
              acreditarse con
              registro y placas del país de procedencia.
              Cobertura únicamente en territorio Mexicano.</p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li>Vigencias diarias (corto plazo, semestrales y anuales)</li>
              <li>Conductores mayores de 18 años.</li>
              <li>Vehículos hasta con 20 años de antigüedad.</li>
            </ul>
          </div>
        </div>
        <a v-scroll-to="'#contact'" class="cont btn1 btn-custom btn-rounded margin-t-30 waves-effect waves-light">
          Contáctanos
          <i class="mdi mdi-arrow-right"></i>
        </a>
      </div>
    </div>
  </section>
  <!--START SERVICES-->
</template>
<style>
@media (max-width: 414px) {

  .section {
    margin-left: -24px;
  }

  .cont.btn1 {
    margin-left: 32.5%
  }
}

@media (min-width: 992px) {
  .col-lg-4-3 {
    flex: 0 0 33.3%;
    max-width: 33.333333%;
  }
}</style>